import { useNavigate } from 'react-router-dom';

export default function FeaturedGuides() {
  const navigate = useNavigate();

  const guides = [
    { icon: 'ri-star-line', title: 'Basetao Review 2026', desc: 'Honest and detailed analysis of features, fees, shipping, and overall user experience with real testimonials.', link: '/article/basetao-review' },
    { icon: 'ri-money-dollar-circle-line', title: 'Basetao Shipping Cost', desc: 'Complete price guide and calculator to estimate your delivery costs before you place any order.', link: '/article/basetao-shipping-cost' },
    { icon: 'ri-coupon-line', title: 'Basetao Coupon Codes', desc: 'Working discount codes and promotional offers verified by our community. Updated weekly for maximum savings.', link: '/article/basetao-coupon-guide' },
    { icon: 'ri-gift-line', title: 'Basetao Discount Guide', desc: 'Learn all the ways to save — from seasonal sales and bulk discounts to referral bonuses and loyalty rewards.', link: '/article/basetao-coupon-guide' },
    { icon: 'ri-building-line', title: 'Basetao Warehouse Info', desc: 'Everything about storage duration, consolidation, QC photo services, and how to manage your parcels efficiently.', link: '/article/basetao-warehouse' },
    { icon: 'ri-shield-check-line', title: 'Is Basetao Legit?', desc: 'Transparent look at safety, reliability, payment protection, and what real customers say about their experience.', link: '/article/is-basetao-legit' },
  ];

  return (
    <section id="featured-guides" className="py-16 md:py-24 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-800 text-xs font-semibold tracking-wide uppercase mb-4">
            Knowledge Base
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
            Featured <span className="italic text-primary-600">Basetao</span> Guides
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto text-base leading-relaxed">
            Dive into our most popular resources — each one carefully researched and written to help you navigate the Basetao ecosystem with confidence.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {guides.map((guide) => (
            <button
              key={guide.title}
              onClick={() => { navigate(guide.link); window.scrollTo(0, 0); }}
              className="group block text-left bg-background-100 rounded-xl p-6 border border-background-200/60 hover:border-primary-200/40 transition-all duration-300 cursor-pointer w-full"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 mb-4 group-hover:bg-secondary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${guide.icon} text-lg`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                {guide.title}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed">{guide.desc}</p>
              <span className="inline-flex items-center gap-1 mt-3 text-xs font-medium text-primary-600">
                Learn More <i className="ri-arrow-right-line text-xs"></i>
              </span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}